// extracted by mini-css-extract-plugin
export default {"root":"StubNotFound_root__2-rea","icon":"StubNotFound_icon__Nkuy4","title":"StubNotFound_title__t0QQ5","description":"StubNotFound_description__Zg7sl"};